import styled from '@emotion/styled';
import Button from '~/shared/components/Button';
import { breakpoints } from '~/theme/breakpoints';
import { theme } from '~/theme';

export const PDPStoreList = styled.ul(() => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    minHeight: '30vh',
    scrollbarGutter: 'stable',
    [breakpoints.xs]: {
        alignSelf: 'flex-start',
        overflow: 'auto',
        whiteSpace: 'nowrap',
        justifyContent: 'space-between',
    },
}));

export const PDPStoreListLi = styled.li(() => ({
    width: '100%',
    display: 'grid',
    padding: `${theme.space[3]} 0`,
    borderBottom: `1px solid ${theme.colors.grey40}`,
    gridTemplateColumns: 'repeat(2, 1fr)',
    columnGap: theme.space[1],
    '&:last-child': {
        borderBottom: '0',
    },
    strong: {
        textTransform: 'capitalize',
        whiteSpace: 'normal',
    },
}));

export const StyledButton = styled(Button)(() => ({
    width: '100%',
    marginTop: theme.space['3'],
}));
